<div class="select-vehicles">
    <mat-label style="color: rgba(0,0,0,.54)">{{ 'vehicles-selector.vehicles' | translate | capitalizeFirst }}:</mat-label>
    <p-multiSelect [options]="availableVehicles" [(ngModel)]="selectedVehicles" optionLabel="displayValue" [filter]="true" [showToggleAll]="true"
        [disabled]="disabled" (onChange)="onMultiSelectChange()" (onPanelHide)="onTouched()" appendTo="body" filterMatchMode="startsWith">

        <ng-template pTemplate="selectedItems">
            <div class="chips-container" [style.min-height]="chipsContainerHeight" [style.max-height]="chipsContainerHeight">
                <ng-container *ngIf="selectedVehicles.length; else placeholderTpl">
                    <span *ngFor="let v of selectedVehicles" class="p-chip">
                        {{ v.displayValue }}
                        <span class="p-chip-remove" (click)="removeVehicle(v); $event.stopPropagation()">
                            <i class="pi pi-times"></i>
                        </span>
                    </span>
                </ng-container>
                <ng-template #placeholderTpl>
                    <span class="placeholder">
                        {{ 'vehicles-selector.vehicles' | translate | capitalizeFirst }}
                    </span>
                </ng-template>
            </div>
        </ng-template>

        <ng-template pTemplate="item" let-vehicle>
            {{ vehicle.displayValue }}
        </ng-template>

    </p-multiSelect>
</div>